import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link as RouterLink } from "react-router-dom";
import { Breadcrumbs,BreadcrumbItem } from "@vds/breadcrumbs";
import styled from "styled-components";

import breadcrumb_arrow from "../../../assets/svgs/breadcrumb_arrow.svg";
import { media } from "utils/style";

class BreadCrumbs extends Component {
  state = {
    breadcrumbList: [],
    shouldRender: false
  };

  componentDidUpdate(prevProps) {
    const { reduxBreadcrumbList } = this.props;

    if (JSON.stringify(reduxBreadcrumbList) !== JSON.stringify(prevProps.reduxBreadcrumbList)) {
      if (reduxBreadcrumbList.length) {
        this.setState({ breadcrumbList: reduxBreadcrumbList, shouldRender: true }, () =>
          setTimeout(() => {
            this.setActivePage();
          }, 1)
        );
      } else {
        this.setState({ shouldRender: false });
      }
    }
  }

  setActivePage = () => {
    const { breadcrumbList } = this.state;
    const lastBreadcrumb = breadcrumbList.length - 1;
    const updatedBreadcrumbList = breadcrumbList.map((breadcrumb, i) => {
      if (i === lastBreadcrumb) {
        return {
          ...breadcrumb,
          state: "active"
        };
      }
      return {
        ...breadcrumb,
        state: "inactive"
      };
    });

    this.setState({ breadcrumbList: updatedBreadcrumbList });
  };

  render() {
    const { shouldRender } = this.state;
    const { loading } = this.props;
    
    return shouldRender && !window.profileError && !loading ? (
      <Container>
        <nav>
          <Breadcrumbs  surface="light">
            {this.state.breadcrumbList.map(breadcrumb => (
              <BreadcrumbItem key={breadcrumb.label} href={breadcrumb.path} state={breadcrumb.state}>
               <span style={{fontFamily:'Verizon-NHG-eDS, Helvetica, Arial, sans-serif'}}>{breadcrumb.label}</span>
              </BreadcrumbItem>
            ))}
          </Breadcrumbs>
        </nav>
      </Container>
    ) : null;
  }
}

const mapStateToProps = ({
  downloadAndDelete: { downloadReady },
  breadcrumbList: reduxBreadcrumbList,
  loadingAndErrorState: { loading }
}) => ({
  downloadReady,
  reduxBreadcrumbList,
  loading
});

export default compose(
  connect(mapStateToProps),
  withRouter
)(BreadCrumbs);

// const OL = styled.ol`
//   display: flex;
//   flex-wrap: wrap;

//   li {
//     position: relative;
//     display: "inline-block";
//     margin: 0px 12px 4px 12px;
//   }

//   li:not(:last-child)::after {
//     position: absolute;
//     top: 2px;
//     right: -20px;
//     content: "/";
//     color: #888;
//     height: 12px;
//     width: 12px;
//     background-size: 12px;
//     background-repeat: no-repeat;
//   }

//   ${media.mobile`
//     li:not(:last-child)::before {
//       top: 1px;      
//     }
//   `}
// `;

const Container = styled.div`
  max-width: 1272px;
  margin: 21px auto 0 auto;

  nav {
    padding: 0 8px;
  }

  ${media.mobile`
    nav {
      padding: 0 4px;
    }
  `}
`;

// const Link = styled(RouterLink)`
//   text-decoration: none;
//   font-size: 12px;
//   line-height: 14px;
//   font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
//   font-weight: ${props => (props.state === "active" ? '700' : '400')};
// `;
